import { render } from "./historyPage.vue?vue&type=template&id=342d684c&scoped=true&ts=true"
import script from "./historyPage.vue?vue&type=script&lang=ts"
export * from "./historyPage.vue?vue&type=script&lang=ts"

import "./historyPage.vue?vue&type=style&index=0&id=342d684c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342d684c"]])

export default __exports__